import { createContext, useContext } from 'react';
import type { RideListItem } from '@ridemaadi/types';
import type { SosAlert } from '../activity';

export interface RideModeState {
  isRideMode: boolean;
  activeRide: RideListItem | null;
  sosActive: boolean;
  sosAlert: SosAlert | null;
  unreadAlerts: number;
  openSos: () => void;
  markAlertsSeen: () => void;
  invalidateRideMode: () => void;
}

export const RideModeContext = createContext<RideModeState | null>(null);

const defaultState: RideModeState = {
  isRideMode: false,
  activeRide: null,
  sosActive: false,
  sosAlert: null,
  unreadAlerts: 0,
  openSos: () => {},
  markAlertsSeen: () => {},
  invalidateRideMode: () => {},
};

export function useRideMode(): RideModeState {
  return useContext(RideModeContext) ?? defaultState;
}
